import React, { useEffect } from 'react'
import Nav from 'react-bootstrap/Nav';
import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

function EmployeeSalaryNavbar() {
    const [activeLink, setActiveLink] = useState('');
    const location = useLocation();

    // useEffect(() => {
    //     if (location.pathname.includes('salaryhistory')) {
    //         setActiveLink('Salary History');
    //     } else {
    //         setActiveLink('Salary Slips');
    //     }
    // }, [location.pathname]);

    const linkClicked = (link) => {
        setActiveLink(link);
    };

    const linkStyle = (link) => ({
        color: activeLink === link ? 'black' : 'gray',
        fontWeight: '500',
    });

    return (
        <>
            <h5 className='mb-4' style={{ marginTop: "30px" }}> {activeLink} </h5>

            {/* <Nav style={{ marginLeft: "-15px" }}>
                <Nav.Link
                    as={NavLink}
                    to="/salary/empsalary/salaryslips"
                    style={linkStyle('Salary Slips')}
                    onClick={() => linkClicked('Salary Slips')}
                >
                    Salary Slips
                </Nav.Link>
                <Nav.Link
                    as={NavLink}
                    to="/salary/empsalary/salaryhistory"
                    style={linkStyle('Salary History')}
                    onClick={() => linkClicked('Salary History')}
                >
                    Salary History
                </Nav.Link>
            </Nav> */}
        </>
    );
}

export default EmployeeSalaryNavbar